import React, { useEffect } from 'react'
import { Flex, Text, Box, Heading, CircularProgress } from '@homebotapp/hb-react-component-catalog'
import { useVerificationFlow } from '../../VerificationFlowContext'

/**
 * VerifyingView Component
 *
 * Checks if the membership is verified and dispatches the appropriate event.
 */
const VerifyingView = () => {
  const { state, dispatch } = useVerificationFlow()
  const { currentPartnerType } = state

  // Get the appropriate membership based on current partner type
  const membership =
    currentPartnerType === 'RealEstateAgent' ? state.realEstateAgentMembership : state.loanOfficerMembership

  const handleVerified = () => {
    dispatch({ type: 'SUCCESS' })
  }

  const handleUnverified = () => {
    dispatch({ type: 'FAILURE' })
  }

  useEffect(() => {
    if (!membership) {
      // No membership to verify, treat as failure
      handleUnverified()
      return
    }

    if (membership.isVerified) {
      handleVerified()
    } else {
      handleUnverified()
    }
  }, [membership])

  return null
}

export default VerifyingView
